<template>
    <header>
        <div class="tracking-controls__status">
            <tabs-field
                :label="$t('pages.referrals.index.controls.status')"
                :options="stateOptions"
                :formData="$route.query"
                valuePath="state"
                size="small"
                @change="changeState($event)"
            ></tabs-field>
        </div>

        <div class="tracking-controls">
            <div class="tracking-controls__filters">
                <text-field
                    :placeholder="$t('pages.referrals.index.controls.search')"
                    :formData="$route.query"
                    valuePath="query"
                    @change="queryChange($event)"
                ></text-field>
                <common-icon class="tracking-controls__filters--search" name="search-gray" size="huge"></common-icon>
            </div>

            <div class="tracking-controls__pagination">
                <select-field
                    :label="$t('pages.referrals.index.controls.pagination')"
                    :options="limitOptions"
                    :formData="$route.query"
                    valuePath="limit"
                    @change="changeLimit($event)"
                ></select-field>
            </div>
        </div>
    </header>
</template>

<script>
    import { importComponents } from '~/helpers'
    import debounce from 'lodash.debounce'
    import config from '../../../config'

    export default {
        components: {
            ...importComponents(require.context('components/form-elements')),
            ...importComponents(require.context('components/form-fields')),
        },

        data() {
            return {
                limitOptions: [10, 20, 50].map((n) => ({
                    label: this.$t('pages.referrals.index.controls.number_per_page', { n }),
                    value: n,
                })),
            }
        },

        computed: {
            stateOptions() {
                return ['open', 'closed', 'all'].map((value) => ({
                    label: this.$t(`pages.referrals.index.statuses.${value}`),
                    value,
                }))
            },
        },

        methods: {
            changeState({ value: state }) {
                let query = { ...this.$route.query, state }
                delete query.status

                this.$router.push({
                    ...this.$route,
                    query: query,
                })
            },

            changeLimit({ value: limit }) {
                this.$router.push({
                    ...this.$route,
                    query: { ...this.$route.query, limit },
                })
            },

            queryChange: debounce(function ({ value: search }) {
                const searchTerm = search.trim()
                let query
                if (searchTerm && searchTerm.length) {
                    query = { ...this.$route.query, query: searchTerm }
                } else {
                    query = { ...this.$route.query }
                    delete query.query
                }

                this.$router.push({ ...this.$route, query })
            }, config.DEBOUNCE.DEFAULT),
        },
    }
</script>
